const processInclude = require('base/util');

const jQuery = require('jquery');

window.jQuery = jQuery;
window.$ = jQuery;

require('app_byl_core/common/polyfills');

// Minimal analytics bootstrap: sets window.bylAnalytics and wires the GA4
// subscribers so events published from this page (e.g. the country selector
// modal) reach the dataLayer, without pulling in the full storefront
// analytics init (CQuotient, Einstein, fitAnalytics, tracking modules...)
// that this page doesn't need.
require('app_byl_core/analytics');
require('app_byl_core/analytics/ga4').init();

processInclude(
  require('app_byl_core/components/countrySelectorModal/countrySelectorModal')
);
